import {
    getMerchantPayout,
    addMerchantPayout,
    updateMerchantPayout,
    updateMerchantDebitBalance,
    fetchMerchantPayoutById,
    getMerchantPayoutCount,
    getIndiviudalMerchantPayoutCount,
    getLienandDebitCount,
    getMerchantPayoutList,
    addMerchantSinglePayout,
    getMerchantBulkPayoutList,
    getMerchantBulkPayoutCount
  } from "../../services/MerchantPayout";
  import {formatSuccess,formatError} from '../../services/commonServices'
  

  export const PAYOUT_REQUESTS_LIST_INITIATED = "PAYOUT_REQUESTS_LIST_INITIATED";
  export const PAYOUT_REQUESTS_INITIATED = "PAYOUT_REQUESTS_INITIATED";
  export const PAYOUT_REQUESTS_LIST_LOADED = "PAYOUT_REQUESTS_LIST_LOADED";

  export const FUND_PAYOUT_INITIATED = "FUND_PAYOUT_INITIATED";
  export const FUND_PAYOUT_FAILED = "FUND_PAYOUT_FAILED";

  export const PAYOUT_REQUESTS_LOADED = "PAYOUT_REQUESTS_LOADED";
  export const PAYOUT_REQUESTS_FAILED = "PAYOUT_REQUESTS_FAILED";

  export const PAYOUT_REQUESTS_COUNT_INITIATED = "PAYOUT_REQUESTS_COUNT_INITIATED";
  export const PAYOUT_REQUESTS_COUNT_LOADED = "PAYOUT_REQUESTS_COUNT_LOADED";
  export const PAYOUT_REQUESTS_COUNT_FAILED  = "PAYOUT_REQUESTS_COUNT_FAILED";

  export const BULK_PAYOUT_REQUESTS_COUNT_INITIATED = "BULK_PAYOUT_REQUESTS_COUNT_INITIATED";
  export const BULK_PAYOUT_REQUESTS_COUNT_LOADED = "BULK_PAYOUT_REQUESTS_COUNT_LOADED";
  export const BULK_PAYOUT_REQUESTS_COUNT_FAILED  = "BULK_PAYOUT_REQUESTS_COUNT_FAILED";

  export const PAYOUT_MERCHANT_REQUESTS_COUNT_INITIATED = "PAYOUT_MERCHANT_REQUESTS_COUNT_INITIATED";
  export const PAYOUT_MERCHANT_COUNT_LOADED = "PAYOUT_MERCHANT_COUNT_LOADED";
  export const PAYOUT_MERCHANT_COUNT_FAILED  = "PAYOUT_MERCHANT_COUNT_FAILED";

  export const MERCHANT_PAYOUT_LIST_COUNT_INITIATED = "MERCHANT_PAYOUT_LIST_COUNT_INITIATED";
  export const MERCHANT_PAYOUT_LIST_COUNT_LOADED = "MERCHANT_PAYOUT_LIST_COUNT_LOADED";
  export const MERCHANT_PAYOUT_LIST_COUNT_FAILED  = "MERCHANT_PAYOUT_LIST_COUNT_FAILED";

  export const MERCHANT_PAYOUT_LIST_INITIATED = "MERCHANT_PAYOUT_LIST_INITIATED";
  export const MERCHANT_PAYOUT_LIST_LOADED = "MERCHANT_PAYOUT_LIST_LOADED";
  export const MERCHANT_PAYOUT_LIST_FAILED  = "MERCHANT_PAYOUT_LIST_FAILED";


  export const MERCHANT_BULK_PAYOUT_LIST_INITIATED = "MERCHANT_BULK_PAYOUT_LIST_INITIATED";
  export const MERCHANT_BULK_PAYOUT_LIST_LOADED = "MERCHANT_BULK_PAYOUT_LIST_LOADED";
  export const MERCHANT_BULK_PAYOUT_LIST_FAILED  = "MERCHANT_BULK_PAYOUT_LIST_FAILED";
  
  export const loadMerchantPayout = (getData) => {
    return (dispatch) => {
      dispatch({ type: PAYOUT_REQUESTS_LIST_INITIATED });
      getMerchantPayout(getData)
        .then((response) => {
          dispatch({ type: PAYOUT_REQUESTS_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: PAYOUT_REQUESTS_FAILED, payload: error.message });
        });
    };
  };
  
  export const loadMerchantPayoutList = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_PAYOUT_LIST_INITIATED });
      getMerchantPayoutList(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_PAYOUT_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_PAYOUT_LIST_FAILED, payload: error.message });
        });
    };
  };

  
  export const loadMerchantBulkPayoutList = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_BULK_PAYOUT_LIST_INITIATED });
      getMerchantBulkPayoutList(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_BULK_PAYOUT_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_BULK_PAYOUT_LIST_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantBulkEntries = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_BULK_PAYOUT_LIST_INITIATED });
      getMerchantBulkPayoutList(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_BULK_PAYOUT_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_BULK_PAYOUT_LIST_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantPayoutCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: PAYOUT_REQUESTS_COUNT_INITIATED });
      getMerchantPayoutCount(getData)
        .then((response) => {
          dispatch({ type: PAYOUT_REQUESTS_COUNT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: PAYOUT_REQUESTS_COUNT_FAILED, payload: error.message });
        });
    };
  };

   export const loadMerchantBulkPayoutCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: BULK_PAYOUT_REQUESTS_COUNT_INITIATED });
      getMerchantBulkPayoutCount(getData)
        .then((response) => {
          dispatch({ type: BULK_PAYOUT_REQUESTS_COUNT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: BULK_PAYOUT_REQUESTS_COUNT_FAILED, payload: error.message });
        });
    };
  };

  

  export const loadMerchantPayoutListCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_PAYOUT_LIST_COUNT_INITIATED });
      getLienandDebitCount(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_PAYOUT_LIST_COUNT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_PAYOUT_LIST_COUNT_FAILED, payload: error.message });
        });
    };
  };


  export const loadIndiviudalMerchantPayoutCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: PAYOUT_MERCHANT_REQUESTS_COUNT_INITIATED });
      getIndiviudalMerchantPayoutCount(getData)
        .then((response) => {
          dispatch({ type: PAYOUT_MERCHANT_COUNT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: PAYOUT_MERCHANT_COUNT_FAILED, payload: error.message });
        });
    };
  };

  

  

  export const getMerchantPayoutById = (id) => {
    return (dispatch) => {
      dispatch({ type: PAYOUT_REQUESTS_INITIATED });
      return fetchMerchantPayoutById(id)
        .then((response) => {
          dispatch({ type: PAYOUT_REQUESTS_LOADED, payload: response.data });
        })
        .catch((error) => {
          dispatch({ type: PAYOUT_REQUESTS_FAILED, payload: formatError(error) });
        });
    };
  };
  
  export const debitMerchantBalance = (data, isEdit, id, navigate) => {
    return (dispatch) => {
      dispatch({ type: PAYOUT_REQUESTS_INITIATED });
      const apiCall = isEdit ? updateMerchantDebitBalance(data) : updateMerchantDebitBalance(data);
      return apiCall
        .then((response) => {
          formatSuccess('Debit request', response.data)
          setTimeout(()=>{
            navigate('/debit-funds');
          },1000)
        })
        .catch((error) => {
          if(error && error.response && error.response.data){
            dispatch({ type: PAYOUT_REQUESTS_FAILED, payload: formatError(error.response.data) });
          }
          else{
            dispatch({ type: PAYOUT_REQUESTS_FAILED, payload: formatError(error.message) });
          }
        });
    };
  };

  export const saveMerchantPayoutAction = (data, isEdit, id, navigate) => {
    return (dispatch) => {
      dispatch({ type: PAYOUT_REQUESTS_INITIATED });
      const apiCall = isEdit ? updateMerchantPayout(id, data) : addMerchantPayout(data);
      return apiCall
        .then((response) => {
          formatSuccess('Fund Request', response.data)
          setTimeout(()=>{
            navigate('/fund-requests');
          },1000)
        })
        .catch((error) => {
          if(error && error.response && error.response.data){
            dispatch({ type: PAYOUT_REQUESTS_FAILED, payload: formatError(error.response.data) });
          }
          else{
            dispatch({ type: PAYOUT_REQUESTS_FAILED, payload: formatError(error.message) });
          }
        });
    };
  };

  export const createFundPayoutAction = (data, navigate) => {
    return (dispatch) => {
        dispatch({ type: FUND_PAYOUT_INITIATED });
        const apiCall = addMerchantSinglePayout(data);
        return apiCall
          .then((response) => {
            formatSuccess('Fund Request', response.data)
          })
          .catch((error) => {
            if(error && error.response && error.response.data){
              dispatch({ type: FUND_PAYOUT_FAILED, payload: formatError(error.response.data) });
            }
            else{
              dispatch({ type: FUND_PAYOUT_FAILED, payload: formatError(error.message) });
            }
      });
    };
 };